'use client';

import { useCallback } from 'react';

import { ScrollButtonProps } from './types';

import { Button } from '@/shared/components/button';
import smoothScroll from '@/shared/utils/smoothScroll';

export const ScrollButton = ({
  target,
  onClick: buttonOnClick,
  ...buttonProps
}: ScrollButtonProps) => {
  const onClick = useCallback(
    (event?: React.MouseEvent<HTMLElement>) => {
      smoothScroll(target);
      buttonOnClick?.(event);
    },
    [buttonOnClick, target],
  );

  return <Button onClick={onClick} {...buttonProps} ariaLabel="ScrollButton" />;
};
